const fifthelement = {
  "id": "fifthelement",
  "title": "Fifth Element",
  "description": {
    "bg": "Разположена на емблематичната първа линия на бул. „Княз Борис I“, жилищната сграда The Fifth Element се отличава със своя изтънчен и модерен дизайн. Проектът е дело на STARH Stanislavov Architects, един от водещите автори на съвременна архитектура в България, и впечатлява със смелата си архитектурна визия.\n\nВертикалните линии на фасадата създават усещане за движение и динамика, докато изчистените бели елементи придават елегантност, лекота и изтънченост. Сградата интерпретира актуалните световни тенденции, вписвайки се естествено и с изтънчен характер в градската среда.\n\nС 15 надземни етажа, проектът предлага разнообразие от функционални жилищни и общи пространства, съчетавайки комфорт, стил и ефективно планиране.\n\nThe Fifth Element е признат за иновация и качество в архитектурата, като бе удостоен с наградата за иновативна жилищна архитектура в категорията „Жилищни сгради от 10 000 кв.м до 20 000 кв.м РЗП“ на престижния Национален конкурс „Сграда на годината 2024“, утвърждавайки го като символ на модерния градски начин на живот.",
    "en": "Located on the iconic first line of Knyaz Boris I Boulevard, the residential building The Fifth Element stands out with its refined and modern design. The project is the work of STARH Stanislavov Architects, one of the leading authors of contemporary architecture in Bulgaria, and impresses with its bold architectural vision.\n\nThe vertical lines of the facade create a sense of movement and dynamism, while the clean white elements add elegance, lightness and refinement. The building interprets current global trends, fitting naturally and with a refined character into the urban environment.\n\nWith 15 above-ground floors, the project offers a variety of functional residential and common spaces, combining comfort, style and efficient planning.\n\nThe Fifth Element has been recognized for innovation and quality in architecture, having been awarded the prize for innovative residential architecture in the category \"Residential buildings from 10,000 sq.m to 20,000 sq.m GFA\" at the prestigious National Competition \"Building of the Year 2024\", establishing it as a symbol of the modern urban way of life.",
    "de": "An der emblematischen ersten Linie des Boulevards Knyaz Boris I gelegen, zeichnet sich das Wohngebäude The Fifth Element durch sein raffiniertes und modernes Design aus. Das Projekt ist ein Werk von STARH Stanislavov Architects, einem der führenden Autoren zeitgenössischer Architektur in Bulgarien, und beeindruckt mit seiner mutigen architektonischen Vision.\n\nDie vertikalen Linien der Fassade erzeugen ein Gefühl von Bewegung und Dynamik, während die klaren weißen Elemente Eleganz, Leichtigkeit und Raffinesse verleihen. Das Gebäude interpretiert aktuelle weltweite Trends und fügt sich natürlich und mit raffiniertem Charakter in das städtische Umfeld ein.\n\nMit 15 oberirdischen Etagen bietet das Projekt eine Vielfalt funktionaler Wohn- und Gemeinschaftsräume und vereint Komfort, Stil und effiziente Planung.\n\nThe Fifth Element wurde für Innovation und Qualität in der Architektur anerkannt und mit dem Preis für innovative Wohnarchitektur in der Kategorie „Wohngebäude von 10.000 bis 20.000 qm BGF“ beim prestigeträchtigen nationalen Wettbewerb „Gebäude des Jahres 2024“ ausgezeichnet, was es zu einem Symbol des modernen städtischen Lebensstils macht.",
    "ru": "Расположенное на знаковой первой линии бульвара «Княз Борис I», жилое здание The Fifth Element выделяется своим изысканным и современным дизайном. Проект создан STARH Stanislavov Architects — одним из ведущих авторов современной архитектуры в Болгарии, и впечатляет смелым архитектурным видением.\n\nВертикальные линии фасада создают ощущение движения и динамики, а чистые белые элементы придают элегантность, легкость и изысканность. Здание интерпретирует актуальные мировые тенденции, органично и с утонченным характером вписываясь в городскую среду.\n\nС 15 надземными этажами проект предлагает разнообразие функциональных жилых и общих пространств, сочетая комфорт, стиль и эффективное планирование.\n\nThe Fifth Element признан за инновации и качество в архитектуре, будучи удостоенным награды за инновационную жилую архитектуру в категории «Жилые здания от 10 000 кв.м до 20 000 кв.м ОПС» на престижном национальном конкурсе «Здание года 2024», что утвердило его как символ современного городского образа жизни."
  },
  "location": {
    "en": "Knyaz Boris I Boulevard, Varna",
    "bg": "бул. Княз Борис I, Варна",
    "de": "Knyaz Boris I Boulevard, Varna",
    "ru": "бул. Княз Борис I, Варна"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.7644951530383!2d27.93666807653709!3d43.2144286806982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a457eab64df8f1%3A0x7b0f1a7fb4954785!2z0JrQvtC80L_Qu9C10LrRgSAi0J_QtdGC0LjRj9GCINC10LvQtdC80LXQvdGCIg!5e0!3m2!1sen!2sbg!4v1759424782627!5m2!1sen!2sbg",
    "directionsUrl": "https://www.google.com/maps/search/?api=1&query=Fifth+Element,+Sofia,+Bulgaria",
    "coordinates": {
      "lat": 43.2144286806982,
      "lng": 27.93666807653709
    }
  },
  "type": "Mixed-Use Development",
  "year": "2023",
  "status": "Completed",
  "heroImage": "/projects/FifthElement/IMG_0168.jpeg",
  "images": [
    "/projects/FifthElement/IMG_0168.jpeg",
    "/projects/FifthElement/IMG_0211.jpeg",
    "/projects/FifthElement/IMG_0578.jpeg",
    "/projects/FifthElement/IMG_2462.jpeg",
    "/projects/FifthElement/IMG_2611.jpeg",
    "/projects/FifthElement/IMG_3376.jpeg",
    "/projects/FifthElement/IMG_6043.jpeg",
    "/projects/FifthElement/IMG_7808.jpeg",
    "/projects/FifthElement/IMG_8976.jpeg",
    "/projects/FifthElement/IMG_9462.jpeg"
  ],
  "features": {
    "en": [
      "Mixed-use development",
      "Commercial retail spaces",
      "Modern office facilities",
      "Residential apartments",
      "Underground parking",
      "Smart building technology",
      "Central location",
      "Public transportation access"
    ],
    "bg": [
      "Смесена застройка",
      "Търговски пространства",
      "Модерни офис съоръжения",
      "Жилищни апартаменти",
      "Подземен паркинг",
      "Интелигентна сградна технология",
      "Централно местоположение",
      "Достъп до градски транспорт"
    ],
    "de": [
      "Gemischte Entwicklung",
      "Gewerbliche Einzelhandelsflächen",
      "Moderne Büroanlagen",
      "Wohnungen",
      "Tiefgarage",
      "Smart Building Technologie",
      "Zentrale Lage",
      "Öffentliche Verkehrsanbindung"
    ],
    "ru": [
      "Смешанная застройка",
      "Коммерческие торговые пространства",
      "Современные офисные помещения",
      "Жилые апартаменты",
      "Подземная парковка",
      "Умные строительные технологии",
      "Центральное местоположение",
      "Доступ к общественному транспорту"
    ]
  },
  "stats": {
    "area": "5,800 m²",
    "floors": "15",
    "units": "48"
  },
  "availableApartments": 0
};

export default fifthelement;
